import React from "react";
import {NavigateFunction} from "react-router-dom";

export function capitalize(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function isValidUrl(url: string): boolean {
    // regex parts
    const protocol = "(https?:\\/\\/)?";
    const dns = "[a-z0-9][a-z0-9\\-.]+";
    const dnsWithTld = `(${dns}\\.[a-z0-9]{2,})`;
    const dnsWithPort = `(${dns}:[0-9]{2,4})`;
    const path = "((\\/[\\w\\-+.:%]*)*)?";
    const query = "((\\?|#)[\\/\\S*]*)?";

    const regexWithTld = new RegExp(`^${protocol}${dnsWithTld}${path}${query}$`, "g");
    const regexWithPort = new RegExp(`^${protocol}${dnsWithPort}${path}${query}$`, "g");
    return regexWithTld.test(url) || regexWithPort.test(url);
}

export const onClickLink = (e: React.MouseEvent, path: string, navigate?: NavigateFunction) => {
    if (e.ctrlKey || e.metaKey) {
        window.open(path, "_blank");
    } else if (navigate) {
        navigate(path);
    } else {
        window.open(path, "_top");
    }
};

export function onKeyEnter(e: any, cb: () => void): void {
    const isKeyEnter = e.key === "Enter";
    if (isKeyEnter) cb();
}

function sortString(a: string, b: string, reverseOrder: boolean): number {
    return (reverseOrder ? a > b : b > a) ? 1 : -1;
}

function sortNumber(a: number, b: number, reverseOrder: boolean): number {
    return reverseOrder ? a - b : b - a;
}

export function sortItems(items: any[], field: string, reverseOrder: boolean = false): any[] {
    return [...items].sort((a, b) => {
        const isTypeNumber =
            typeof a[field] === "number" && typeof b[field] === "number";

        return isTypeNumber
            ? sortNumber(a[field], b[field], reverseOrder)
            : sortString(a[field].toLowerCase(), b[field].toLowerCase(), reverseOrder);
    });
}
